<template>
  <div class="topicBox">
    <div class="gradientBox">
      <div class="titleBox">
        <div class="titleLeft" @click="closeWebs">
          <img src="../../assets/images/titleArrow.png" alt="" />
        </div>
        <div class="titleCentre">临床思维能力</div>
        <div class="titleRight"></div>
      </div>
      <div class="knowledgHome">
        <img :src="knowledgeHomeImage" alt="" @click="handleKnowledgeHomeClick" />
      </div>
      <div class="listBox">
        <div
          class="liBox"
          :class="{ odd: index % 2 === 0, even: index % 2 === 1 }"
          v-for="(item, index) in standingList"
          :key="index"
          @click="handleClick(item)"
        >
          <div class="liCenter">
            <div class="liTitle">{{ item.label }}</div>
            <!-- <div class="liDesc">丰富题库，随时随地随意刷</div> -->
          </div>
          <div class="liRight">
            <img :src="getArrow(index)" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { categoryGetList } from "@/api/knowledge/index.js";
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      standingList: [],
    };
  },
  created() {
    this.categoryGetListData();
  },
  methods: {
    getBannerPrefixFromRoute() {
      const routePrefix =
        this.$route.query.filePrefix ||
        this.$route.query.prefix ||
        this.$route.query.origin ||
        "";
      if (routePrefix) {
        localStorage.setItem("bannerFilePrefix", routePrefix);
      }
      return (
        routePrefix ||
        localStorage.getItem("bannerFilePrefix") ||
        window.location.origin ||
        ""
      );
    },
    formatKnowledgeImageUrl(url) {
      if (!url) {
        return "";
      }
      if (/^(https?:)?\/\//i.test(url)) {
        return encodeURI(url);
      }
      const imgPrefix = String(this.imgUrl || `${window.location.origin}/file/`).replace(
        /\/+$/,
        ""
      );
      const normalizedPath = String(url).startsWith("/") ? String(url) : `/${String(url)}`;
      if (/\/file$/i.test(imgPrefix) && normalizedPath.startsWith("/file/")) {
        return encodeURI(`${imgPrefix}${normalizedPath.replace(/^\/file/, "")}`);
      }
      return encodeURI(`${imgPrefix}${normalizedPath}`);
    },
    async categoryGetListData() {
      const globalIdentify =
        this.$store.getters.identify ||
        localStorage.getItem("identify") ||
        localStorage.getItem("dentify") ||
        "GVHQNA";
      const setList = {
        identify: globalIdentify,
        majorType: 1,
        level: 2,
      };
      const { data } = await categoryGetList(setList);
      this.standingList = Array.isArray(data)
        ? data.filter((item) => Number(item.code) !== 6)
        : [];
    },
    getArrow(index) {
      // 单数(index为偶数)用arrowTwo，双数(index为奇数)用arrowOne
      return index % 2 === 0
        ? require("../../assets/icons/knowledgeArrowTwo.png")
        : require("../../assets/icons/knowledgeArrowOne.png");
    },
    
    closeWebs() {
      wx.miniProgram.postMessage({
						data: {
							action:"back",
						}
					})
      wx.miniProgram.navigateBack();
    },
    handleKnowledgeHomeClick() {
      if (!this.knowledgePointJumpUrl) {
        return;
      }
      window.location.href = this.knowledgePointJumpUrl;
    },

    handleClick(item) {
      const filePrefix = this.getBannerPrefixFromRoute();
      // 点击跳转逻辑
      this.$router.push({
        path: "/knowledgeList",
        query: {
          code: item.code,
          type: 0,
          label: item.label ,
          filePrefix,
        },
      });
    },
  },
  computed: {
    knowledgeHomeImage() {
      const configImage = this.$store.getters.knowledgePointImageUrl;
      return (
        this.formatKnowledgeImageUrl(configImage) ||
        require("../../assets/icons/knowledgHome.png")
      );
    },
    knowledgePointJumpUrl() {
      return this.$store.getters.knowledgePointJumpUrl || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.topicBox {
  .gradientBox {
    width: 100%;
    .titleBox {
      padding: 44px 16px 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .titleLeft {
        text-align: center;
        line-height: 20px;
        width: 20px;
        height: 20px;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .titleCentre {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #121212;
      }
      .titleRight {
        width: 20px;
        height: 20px;
      }
    }
    .knowledgHome {
      padding: 10px 15px;
      width: 100%;
      img {
        width: 100%;
        height: 100px;
      }
    }
    .listBox {
      margin-top: 2px;
      padding: 0 16px;
      width: 100%;
      .liBox {
        display: flex;
        align-items: center;
        width: 100%;
        height: 90px;
        padding: 0 16px;
        margin-bottom: 12px;
        border-radius: 12px;
        box-sizing: border-box;
        &.odd {
          background: #f5f9fe;
        }
        &.even {
          background: #f5f5fe;
        }
        .liCenter {
          flex: 1;
          .liTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            margin-bottom: 6px;
          }
          .liDesc {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #999999;
          }
        }
        .liRight {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
